import { render, staticRenderFns } from "./Incident.vue?vue&type=template&id=a2e0268a&scoped=true&"
import script from "./Incident.vue?vue&type=script&lang=ts&"
export * from "./Incident.vue?vue&type=script&lang=ts&"
import style0 from "./Incident.vue?vue&type=style&index=0&id=a2e0268a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e0268a",
  null
  
)

export default component.exports